import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("iframe", {
    style: { "display": "none" },
    onload: "resizeTextarea(1,10)"
}, null, -1);
const _hoisted_2 = { class: "footerFixed" };
const _hoisted_3 = {
    id: "all_wrapper",
    class: "inquiry"
};
const _hoisted_4 = { class: "wrapper_1" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("h2", null, "お問合せ", -1);
const _hoisted_6 = { class: "inner" };
const _hoisted_7 = /*#__PURE__*/ _createStaticVNode("<p class=\"lead\">当社へのお問い合わせは下記お問い合わせフォームよりお送りください。</p><ul class=\"step_3\"><li class=\"active\">入力<i class=\"fas fa-caret-up step-triangle\"></i></li><li class=\"off\">確認</li><li class=\"off\">完了</li></ul>", 2);
const _hoisted_9 = ["onSubmit"];
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode("お名前"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須")
], -1);
const _hoisted_11 = {
    key: 0,
    class: "err"
};
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode("メール"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須")
], -1);
const _hoisted_13 = {
    key: 0,
    class: "err"
};
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode("電話番号"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須")
], -1);
const _hoisted_15 = {
    key: 0,
    class: "err"
};
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode("種類"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須")
], -1);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, null, -1);
const _hoisted_18 = ["value"];
const _hoisted_19 = {
    key: 0,
    class: "err"
};
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode("件名"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須")
], -1);
const _hoisted_21 = {
    key: 0,
    class: "err"
};
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("dt", { class: "must" }, [
    /*#__PURE__*/ _createTextVNode("内容"),
    /*#__PURE__*/ _createElementVNode("br", { class: "pc" }),
    /*#__PURE__*/ _createElementVNode("span", { class: "must" }, "必須")
], -1);
const _hoisted_23 = {
    key: 0,
    class: "err"
};
const _hoisted_24 = { class: "bt_box" };
const _hoisted_25 = {
    key: 0,
    class: "err_list"
};
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("ul", null, [
    /*#__PURE__*/ _createElementVNode("li", null, [
        /*#__PURE__*/ _createElementVNode("button", {
            type: "submit",
            id: "submit-button",
            class: "bt_next"
        }, " 送信確認 ")
    ])
], -1);
import { ref, reactive, watch, onMounted, onBeforeMount, onUnmounted } from 'vue';
import axios from 'axios';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import InertiaUtil from '@util/InertiaUtil';
import Alert from '@util/BrowserAlert';
import PageExitConfirm from '@util/PageExitConfirm';
import { isObjEmpty } from '@util/Common';
export default /*#__PURE__*/ _defineComponent({
    __name: 'inquiry',
    props: {
        common: null,
        errors: null
    },
    setup(__props) {
        var _a, _b, _c, _d, _e, _f;
        const props = __props;
        const validate = reactive({ shot: false });
        const form = InertiaUtil.getForm({
            name: (_b = (_a = props === null || props === void 0 ? void 0 : props.common['auth.user']) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '',
            email: (_d = (_c = props === null || props === void 0 ? void 0 : props.common['auth.user']) === null || _c === void 0 ? void 0 : _c.email) !== null && _d !== void 0 ? _d : '',
            tel: (_f = (_e = props === null || props === void 0 ? void 0 : props.common['auth.user']) === null || _e === void 0 ? void 0 : _e.tel) !== null && _f !== void 0 ? _f : '',
            inquiry_type_id: null,
            subject: '',
            content: '',
        }, props.common.path);
        const options = ref([]);
        watch(() => form.tel, () => {
            const pattern = /[^0-9-]/g;
            form.tel = form.tel.replace(pattern, '');
        });
        // 文字数チェック
        watch(() => form.name, (value) => {
            if (Alert.charLimitText(value)) {
                form.name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.email, (value) => {
            if (Alert.charLimitText(value)) {
                form.email = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.subject, (value) => {
            if (Alert.charLimitText(value)) {
                form.subject = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.content, (value) => {
            if (Alert.charLimitTextArea(value)) {
                form.content = value.substring(0, Alert.TEXTAREA_LIMIT_NUMBER);
            }
        });
        // 編集チェック
        watch(() => form, () => PageExitConfirm.addEvent(), { deep: true });
        const onCheck = () => {
            PageExitConfirm.removeEvent();
            InertiaUtil.post(form, route('inquiry.verify'), () => { validate.shot = true; });
        };
        onBeforeMount(() => {
            axios.get(route('inquiry-types')).then(response => {
                var _a;
                options.value = (_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : null;
            });
        });
        onMounted(() => {
            validate.shot = isObjEmpty(props.errors);
        });
        onUnmounted(() => {
            PageExitConfirm.removeEvent();
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _hoisted_1,
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _hoisted_5,
                            _createElementVNode("div", _hoisted_6, [
                                _hoisted_7,
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(onCheck, ["prevent"])
                                }, [
                                    _createElementVNode("dl", null, [
                                        _hoisted_10,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).name) = $event)),
                                                type: "text",
                                                name: "f_name",
                                                class: "w40",
                                                placeholder: "例：山田 太郎",
                                                autofocus: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(form).name]
                                            ]),
                                            (validate.shot && ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.name))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(props.errors.name), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_12,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).email) = $event)),
                                                type: "email",
                                                name: "f_mail",
                                                class: "wmax",
                                                placeholder: "例：info@sharementors.jp"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).email]
                                            ]),
                                            (validate.shot && ((_b = props.errors) === null || _b === void 0 ? void 0 : _b.email))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(props.errors.email), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_14,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).tel) = $event)),
                                                type: "text",
                                                name: "f_tel",
                                                class: "w50",
                                                placeholder: "例：092-000-0000",
                                                maxlength: "13"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).tel]
                                            ]),
                                            (validate.shot && ((_c = props.errors) === null || _c === void 0 ? void 0 : _c.tel))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(props.errors.tel), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_16,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).inquiry_type_id) = $event)),
                                                name: "",
                                                id: "sel_1",
                                                class: "w50"
                                            }, [
                                                _hoisted_17,
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: option.id
                                                    }, _toDisplayString(option.name), 9, _hoisted_18));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(form).inquiry_type_id]
                                            ]),
                                            (validate.shot && ((_d = props.errors) === null || _d === void 0 ? void 0 : _d.inquiry_type_id))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(props.errors.inquiry_type_id), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_20,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(form).subject) = $event)),
                                                type: "text",
                                                name: "f_subject",
                                                class: "wmax",
                                                placeholder: "例：会員登録について"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).subject]
                                            ]),
                                            (validate.shot && ((_e = props.errors) === null || _e === void 0 ? void 0 : _e.subject))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(props.errors.subject), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _hoisted_22,
                                        _createElementVNode("dd", null, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(form).content) = $event)),
                                                name: "f_content",
                                                id: "textarea_1",
                                                oninput: "resizeTextarea(1,10)",
                                                placeholder: "入力してください"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).content]
                                            ]),
                                            (validate.shot && ((_f = props.errors) === null || _f === void 0 ? void 0 : _f.content))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(props.errors.content), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                        (validate.shot)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (error) => {
                                                    return (_openBlock(), _createElementBlock("p", null, _toDisplayString(error), 1));
                                                }), 256))
                                            ]))
                                            : _createCommentVNode("", true),
                                        _hoisted_26
                                    ])
                                ], 40, _hoisted_9)
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
